var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "form", staticClass: "form", attrs: { id: "form" } },
    [
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.authType === "login",
              expression: "this.authType === 'login'",
            },
          ],
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.validate()
            },
          },
        },
        [
          _vm._l(_vm.currentConfig.fields, function (field) {
            return _c(
              "div",
              { key: field.name },
              [
                field.name === "password"
                  ? _c(
                      "div",
                      { staticClass: "password-wrapper" },
                      [
                        _c("InputField", {
                          attrs: {
                            name: field.name,
                            type: field.type,
                            label: _vm.$t(field.label),
                            validation: field.validation,
                            "data-qa": field.dataQa,
                            autocomplete: field.autocomplete,
                            error: _vm.errors[field.name] || "",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.validateField(field.name)
                            },
                          },
                          model: {
                            value: _vm.form[field.name],
                            callback: function ($$v) {
                              _vm.$set(_vm.form, field.name, $$v)
                            },
                            expression: "form[field.name]",
                          },
                        }),
                      ],
                      1
                    )
                  : _c("InputField", {
                      attrs: {
                        name: field.name,
                        type: field.type,
                        label: _vm.$t(field.label),
                        validation: field.validation,
                        "data-qa": field.dataQa,
                        autocomplete: field.autocomplete,
                        error: _vm.errors[field.name] || "",
                      },
                      on: {
                        blur: function ($event) {
                          return _vm.validateField(field.name)
                        },
                      },
                      model: {
                        value: _vm.form[field.name],
                        callback: function ($$v) {
                          _vm.$set(_vm.form, field.name, $$v)
                        },
                        expression: "form[field.name]",
                      },
                    }),
              ],
              1
            )
          }),
          this.authType === "login"
            ? _c("div", { staticClass: "forgot-link" }, [
                _c("p", [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("auth.forgot")) + "\n        "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "underline",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.forgot()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.link")))]
                  ),
                ]),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "custom-btn primary",
              attrs: { type: "submit", "data-qa": _vm.currentConfig.submitQa },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t(_vm.currentConfig.submitText)) +
                  "\n    "
              ),
            ]
          ),
        ],
        2
      ),
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.authType === "signup",
              expression: "this.authType === 'signup'",
            },
          ],
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.validate()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "name-inputs" },
            _vm._l(
              _vm.currentConfig.fields.filter(
                (f) => f.wrapperClass === "name-input"
              ),
              function (field) {
                return _c("InputField", {
                  key: field.name,
                  attrs: {
                    name: field.name,
                    type: field.type,
                    label: _vm.$t(field.label),
                    validation: field.validation,
                    autocomplete: field.autocomplete,
                    error: _vm.errors[field.name] || "",
                  },
                  on: {
                    blur: function ($event) {
                      return _vm.validateField(field.name)
                    },
                  },
                  model: {
                    value: _vm.form[field.name],
                    callback: function ($$v) {
                      _vm.$set(_vm.form, field.name, $$v)
                    },
                    expression: "form[field.name]",
                  },
                })
              }
            ),
            1
          ),
          _vm._l(
            _vm.currentConfig.fields.filter(
              (f) => !f.wrapperClass && f.name !== "promo"
            ),
            function (field) {
              return _c("InputField", {
                key: field.name,
                attrs: {
                  name: field.name,
                  type: field.type,
                  label: _vm.$t(field.label),
                  validation: field.validation,
                  autocomplete: field.autocomplete,
                  error: _vm.errors[field.name] || "",
                },
                on: {
                  blur: function ($event) {
                    return _vm.validateField(field.name)
                  },
                },
                model: {
                  value: _vm.form[field.name],
                  callback: function ($$v) {
                    _vm.$set(_vm.form, field.name, $$v)
                  },
                  expression: "form[field.name]",
                },
              })
            }
          ),
          _vm.promoField
            ? _c(
                "div",
                { staticClass: "promo-toggle" },
                [
                  !_vm.showPromo
                    ? _c(
                        "a",
                        {
                          staticClass: "underline",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.openPromo.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            { staticClass: "material-icons promo-picto" },
                            [_vm._v("local_offer")]
                          ),
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t(_vm.promoField.label)) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c("InputField", {
                        ref: "promoInput",
                        attrs: {
                          name: _vm.promoField.name,
                          type: _vm.promoField.type,
                          label: _vm.$t(_vm.promoField.label),
                          validation: _vm.promoField.validation,
                          scope: _vm.currentConfig.scope,
                          autocomplete: _vm.promoField.autocomplete,
                        },
                        model: {
                          value: _vm.form[_vm.promoField.name],
                          callback: function ($$v) {
                            _vm.$set(_vm.form, _vm.promoField.name, $$v)
                          },
                          expression: "form[promoField.name]",
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.currentConfig.checkboxes || [], function (checkbox) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !(checkbox.name === "trial" && _vm.isNotProduction),
                    expression:
                      "!(checkbox.name === 'trial' && isNotProduction)",
                  },
                ],
                key: checkbox.name,
                staticClass: "checkbox-wrapper",
              },
              [
                _c("label", { attrs: { for: checkbox.name } }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          checkbox.name === "trial" &&
                            _vm.form.promo &&
                            _vm.form.promo.length
                            ? "auth.trial.promo"
                            : checkbox.label
                        )
                      ) +
                      "\n        "
                  ),
                  checkbox.linkUrl
                    ? _c(
                        "a",
                        {
                          staticClass: "underline",
                          attrs: { href: checkbox.linkUrl },
                        },
                        [_vm._v(_vm._s(_vm.$t(checkbox.linkText)))]
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "checkbox" }, [
                  _c("div", { staticClass: "custom-checkbox" }, [
                    _c("input", {
                      class: {
                        input: true,
                        "is-danger": _vm.errors[checkbox.name],
                      },
                      attrs: {
                        name: checkbox.name,
                        id: checkbox.name,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: _vm.getCheckboxValue(checkbox.name),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleCheckboxChange(checkbox.name, $event)
                        },
                      },
                    }),
                    _vm._m(0, true),
                  ]),
                ]),
              ]
            )
          }),
          _c(
            "button",
            { staticClass: "custom-btn primary", attrs: { type: "submit" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t(_vm.currentConfig.submitText)) +
                  "\n    "
              ),
            ]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("span", [_vm._v("check")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }